import { render, staticRenderFns } from "./Volunteering.vue?vue&type=template&id=6420ffe1&scoped=true&"
import script from "./Volunteering.vue?vue&type=script&lang=ts&"
export * from "./Volunteering.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6420ffe1",
  null
  
)

/* custom blocks */
import block0 from "./Volunteering.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports